import { createRouter, createWebHistory,createWebHashHistory} from 'vue-router'

const routes = [
  // {
  //   path: '/',
  //   redirect: '/home',
  // },
 
  
  {
    path: '/',
    name: 'Index',
    redirect: '/home',
    component: () => import(/* webpackChunkName: "home" */ './pages/index/index.vue'),
    children:[
      {
        path: '/home',
        component: () => import('@/pages/index/home.vue'),
        name: 'Home',
      },
      {
        path: '/pass',
        component: () => import('@/pages/pass/index.vue'),
        name: 'Pass',
      },{
        path: '/game',
        component: () => import('@/pages/game/index.vue'),
        name: 'Game',
      },{
        path: '/my',
        component: () => import('@/pages/my/index.vue'),
        name: 'My',
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import('@/pages/login/login.vue'),
  },{
    path: '/register',
    name: 'register',
    component: () =>
      import('@/pages/login/register.vue'),
  },{
    path:"/forgot",
    name: 'forgot',
    component: () =>
      import('@/pages/login/forgot.vue'),
  },{
    path:"/lock",
    name: 'lock',
    component: () =>
      import('@/pages/index/lock.vue'),
  },{
    path:"/search",
    name: 'search',
    component: () =>
      import('@/pages/index/search.vue'),
  },{
    path:'/selTextbook',
    name: 'selTextbook',
    component: () =>
      import('@/pages/index/selTextbook.vue'),
  },{
    path:'/bookList',
    name: 'bookList',
    component: () =>
      import('@/pages/index/bookList.vue'),
  },{
    path:'/booDetail',
    name: 'booDetail',
    component: () =>
      import('@/pages/index/booDetail.vue'),
  },{
    path:'/unitDetail',
    name: 'unitDetail',
    component: () =>
      import('@/pages/index/unitDetail.vue'),
  },{
    path:'/word',
    name: 'word',
    component: () =>
      import('@/pages/index/word.vue'),
  },{
    path:'/write',
    name: 'write',
    component: () =>
      import('@/pages/index/write.vue'),
  },{
    path:'/collect',
    name: 'collect',
    component: () =>
      import('@/pages/index/collect.vue'),
  },{
    path:'/wrongList',
    name: 'wrongList',
    component: () =>
      import('@/pages/index/wrongList.vue'),
  },{
    path:'/glossary',
    name: 'glossary',
    component: () =>
      import('@/pages/pass/glossary.vue'),
  },{
    path:'/chooseUnit',
    name: 'chooseUnit',
    component: () =>
      import('@/pages/pass/chooseUnit.vue'),
  },{
    path:"/dictation",
    name: 'dictation',
    component: () =>
      import('@/pages/pass/dictation.vue'),
  },{
    path:'/bookWrong',
    name: 'bookWrong',
    component: () =>
      import('@/pages/pass/bookWrong.vue'),
  },{
    path:'/writeWrong',
    name: 'writeWrong',
    component: () =>
      import('@/pages/pass/writeWrong.vue'),
  },{
    path:'/answerGame',
    name: 'answerGame',
    component: () =>
      import('@/pages/pass/answerGame.vue'),
  },{
    path:'/score',
    name: 'score',
    component: () =>
      import('@/pages/pass/score.vue'),
  },
  {
    path:'/funGame',
    name: 'funGame',
    component: () =>
      import('@/pages/game/funGame.vue'),
  },{
    path:'/gameScore',
    name: 'gameScore',
    component: () =>
      import('@/pages/game/gameScore.vue'),
  },{
    path:'/ranking',
    name: 'ranking',
    component: () =>
      import('@/pages/game/ranking.vue'),
  },{
    path:'/distribution',
    name: 'distribution',
    component: () =>
      import('@/pages/my/distribution.vue'),
  },{
    path:"/apply",
    name: 'apply',
    component: () =>
      import('@/pages/my/apply.vue'),
  },{
    path:'/withdraw',
    name: 'withdraw',
    component: () =>
      import('@/pages/my/withdraw.vue'),
  },{
    path:'/bank',
    name: 'bank',
    component: () =>
      import('@/pages/my/bank.vue'),
  },{
    path:'/withdrawRod',
    name: 'withdrawRod',
    component: () =>
      import('@/pages/my/withdrawRod.vue'),
  },{
    path:'/directRod',
    name: 'directRod',
    component: () =>
      import('@/pages/my/directRod.vue'),
  },{
    path:'/inviteRod',
    name: 'inviteRod',
    component: () =>
      import('@/pages/my/inviteRod.vue'),
  },{
    path:'/myLeader',
    name: 'myLeader',
    component: () =>
      import('@/pages/my/myLeader.vue'),
  },{
    path:'/inviteLink',
    name: 'inviteLink',
    component: () =>
      import('@/pages/my/inviteLink.vue'),
  },{
    path:'/teamIncome',
    name: 'teamIncome',
    component: () =>
      import('@/pages/my/teamIncome.vue'),
  },{
    path:'/memberQuota',
    name: 'memberQuota',
    component: () =>
      import('@/pages/my/memberQuota.vue'),
  },{
    path:'/agentQuota',
    name: 'agentQuota',
    component: () =>
      import('@/pages/my/agentQuota.vue'),
  },{
    path:'/myInfo',
    name: 'myInfo',
    component: () =>
      import('@/pages/my/myInfo.vue'),
  },{
    path:'/editPsw',
    name: 'editPsw',
    component: () =>
      import('@/pages/my/editPsw.vue'),
  },{
    path:'/membership',
    name: 'membership',
    component: () =>
      import('@/pages/my/membership.vue'),
  },{
    path:'/studyInfo',
    name: 'studyInfo',
    component: () =>
      import('@/pages/my/studyInfo.vue'),
  },{
    path:'/agreement',
    name: 'agreement',
    component: () =>
      import('@/pages/my/agreement.vue'),
  }
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// 0-9，a-z, length:8
const randomString = () => {
  return Math.random().toString(36).slice(-8)
}

router.beforeEach((to) => {
  
})

router.afterEach(() => {
  // 隐藏菜单
  // hideMenuItems()
})
